import Dashboard from "../dashboard/Dashboard";
import BasicInfo from "../../components/basic-info/BasicInfo";
import Button from "../../components/buttons/Button";
import ProfilePhoto from "../../components/profile-photo/ProfilePhoto";
import "../../components/generalComponents.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getPartnerDetails,
  PartnerStatus,
  updateStatus,
} from "../../services/partner.service";
import formatDate from "../../utils/date.formater";
import showToast from "../../utils/show.toast";
import StatusUpdateButton from "./StatusUpdateButton";
import ChipList from "../../components/chip-list/ChipList";
import MicroChipList from "../../components/micro-chip-list/MicroChipList";
import { IPartnerDetails, StatusUpdateResponse } from "../reviews/types";
import { updateRequest } from "../../services/api.service";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PartnerDetails() {
  const [error, setError] = useState<string | undefined>(undefined);
  const [partnerDetail, setPartnerDetail] = useState<IPartnerDetails>({
    firstName: "",
    lastName: "",
    email: "",
    userId: 0,
    dateCreated: "",
    createdAt: "",
    profilePictureUrl: "",
    languagesSpoken: [],
    languagesTaught: [],
    role: {
      type: "",
      merchantType: "",
    },
  });

  const { requestId } = useParams();
  const query = useQuery();
  const status = query.get("status");
  const navigate = useNavigate();

  const fetchDetail = async (requestId: string | undefined) => {
    try {
      const endpoint = `merchants/partners/${requestId}`;
      const response = await getPartnerDetails(endpoint);
      setPartnerDetail(response);
      setError(undefined);
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : "There was error fetching partner details!";
      setError(message);
      showToast(message, true);
      return;
    }
  };

  useEffect(() => {
    fetchDetail(requestId);
  }, [requestId]);

  return (
    <Dashboard>
      <div>
        <StatusUpdateButton
          requestId={requestId as string}
          status={status as PartnerStatus}
          listStatus={status as string}
        />
      </div>

      <div className="section">
        <div className="profile-photo-and-names">
          <ProfilePhoto imageUrl={partnerDetail?.profilePictureUrl} />

          <div className="first-and-last-name">
            <BasicInfo title="First Name" data={partnerDetail.firstName} />
            <BasicInfo title="Last Name" data={partnerDetail.lastName} />
          </div>
        </div>

        <div className="more-profile-info">
          <BasicInfo title="Email Address" data={partnerDetail.email} />
          <BasicInfo
            title="Requested Date"
            data={formatDate((partnerDetail?.createdAt as any) ?? null)}
          />

          <ChipList
            title="Spoken Language(s)"
            dataObj={partnerDetail.languagesSpoken}
          />
          <MicroChipList
            title="Language(s) To Teach"
            data={partnerDetail.languagesTaught as []}
          />
        </div>
      </div>
    </Dashboard>
  );
}
